import { NavLink, useSearchParams } from "react-router-dom";
import LoginForm from "./LoginForm";
import { useEffect, useRef } from "react";
import { authService } from "../../../services/auth/authService";
import { userService } from "../../../services/user/userService";
import Logo from "../../../assets/logo-2MAX-large.png";
import CommonFooter from "../../../components/CommonFooter";
import { useKeepQueryParams } from "../../../router/routerHelpers";
import { t } from "i18next";

function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const keepQueryParams = useKeepQueryParams();
  const { validateUser } = authService();
  const { getLoggedUserHomeUrl } = userService();
  const didValidate = useRef(false);

  useEffect(() => {
    const guid = searchParams.get("guid");
    if (!guid || didValidate.current) return;
    // the activation link is single-use: never fire it twice (StrictMode)
    didValidate.current = true;
    void validateUser(guid).then(
      async () => {
        // validateUser auto-logged the user in; hard navigation like
        // LoginForm's to re-inject the CSP headers Stripe needs
        const uid = searchParams.get("uid");
        if (uid) {
          window.location.href = `/profile-share/${uid}`;
          return;
        }
        // Note: unlike LoginForm's regular submit path, this activation-link
        // flow never needs to accept a pending sponsorship itself — when
        // this guid was issued (at registration), the sponsorship was
        // already accepted server-side if a token was present.
        window.location.href = await getLoggedUserHomeUrl();
      },
      () => {
        // used/invalid link: fall back to the normal login form (keeps ?uid)
        setSearchParams((prev) => {
          prev.delete("guid");
          return prev;
        });
      },
    );
  }, [searchParams, setSearchParams, validateUser, getLoggedUserHomeUrl]);

  return (
    <>
      <div className="auth-screen">
        <img src={Logo} alt="2 Minutes Max" className="logo" />
        <div className="auth-card">
          <div className="card_body">
            <LoginForm
              profileShareUid={searchParams.get("uid") ?? undefined}
              premiumSponsorshipToken={
                searchParams.get("sponsorshipToken") ?? undefined
              }
              premiumSponsorshipEmail={searchParams.get("email") ?? undefined}
            />
            <div className="lblock --txt--center">
              <p className="auth-cta">{t("auth:login.NO_ACCOUNT")}</p>
              <NavLink
                className="link --underlined"
                to={keepQueryParams("/register-choice")}
              >
                {t("login.SIGN_UP")}
              </NavLink>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </>
  );
}

export default LoginPage;
